import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('useOrganizations');

    return {
        FETCHING_SEATS_ERROR: t('fetchingSeatsError')
    };
};

export default useTranslation;
